import MembersGroupUserName from "./MembersGroupUserName";
import MembersGroupUserLink from "./MembersGroupUserLink";

import MembersGroupName from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupName";
import MembersGroupLink from "../../../../auth/components/membersGroup/MembersGroupDetail/MembersGroupLink";

import UserName from "../../../../auth/components/user/UserDetail/UserName";
import UserLink from "../../../../auth/components/user/UserDetail/UserLink";
import { toStringDisplay as toStringGroupType } from "../../../types/models/GroupType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const MembersGroupUserDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="MembersGroupUser-detail-title"
                    >
                        { label || t`Members Group User` }: <MembersGroupUserName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="MembersGroupUser-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="MembersGroupUser-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } data-testid="membersGroupId-label" sx={{ textAlign: "left" }}><Trans>Members Group</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="membersGroupId-value" sx={{ textAlign: "left" }}>{ data.membersGroupId ? (<MembersGroupLink id={ data.membersGroupId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="ownedMembersGroupId-label" sx={{ textAlign: "left" }}><Trans>User</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="ownedMembersGroupId-value" sx={{ textAlign: "left" }}>{ data.ownedMembersGroupId ? (<UserLink id={ data.ownedMembersGroupId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default MembersGroupUserDetail;
